import { BrowserModule } from "@angular/platform-browser";
import { FormsModule } from "@angular/forms";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { AngularFontAwesomeModule } from "angular-font-awesome";
import { EnvironmentsModule } from "../environments/environment-variables.module";
import { PopoverModule } from "ngx-smart-popover";
import { MatDialogModule } from "@angular/material";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { LoginModule } from "./login/login.module";
import { ForgotPasswordModule } from "./forgot-password/forgot-password.module";
import { LayoutModule } from "./layout/layout.module";
import { NotFoundComponent } from "./not-found/not-found.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { NgxLoadingModule, ngxLoadingAnimationTypes } from "ngx-loading";
import { UserTypeModule } from "../app/user-type/user-type.module";
import { UpdateInstitutionModule } from "../app/update-institution/update-institution.module";
import { ComponentsModule } from "../components/form-components.module";
import { HeaderModule } from "../components/header-components.module";
import { RegisterModule } from "./register/register.module";
import { AuthGuard } from "./auth-guard";
import { AngularWebStorageModule } from "angular-web-storage";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { Ng2SmartTableModule } from "ng2-smart-table";
import { Interceptor } from "../providers/http.interceptor";
@NgModule({
  declarations: [AppComponent, NotFoundComponent],
  imports: [
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.wanderingCubes,
      backdropBackgroundColour: "rgba(0,0,0,0.1)",
      backdropBorderRadius: "4px",
      primaryColour: "#ffffff",
      secondaryColour: "#ffffff",
      tertiaryColour: "#ffffff",
    }),
    FormsModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    AngularFontAwesomeModule,
    BrowserAnimationsModule,
    ComponentsModule,
    UserTypeModule,
    HeaderModule,
    PopoverModule,
    MatDialogModule,
    MatSnackBarModule,
    EnvironmentsModule,
    RegisterModule,
    AngularWebStorageModule,
    UpdateInstitutionModule,
    MatButtonModule,
    LoginModule,
    ForgotPasswordModule,
    LayoutModule,
    MatIconModule,
    DragDropModule,
    Ng2SmartTableModule,
  ],
  exports: [
    AppRoutingModule,
    ComponentsModule,
    UserTypeModule,
    UpdateInstitutionModule,
  ],
  providers: [
    AuthGuard,
    { provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
